import { readGeoConsentRequired } from '@repo/web-chrome/lib/cookie-consent/read-geo-consent-required';
import { COOKIE_CONSENT_KEY } from '@repo/web-chrome/lib/cookie-consent/storage-key';

export function hasConsent(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (!readGeoConsentRequired()) {
    return true;
  }
  return localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted';
}
